import React from 'react';
import Modal from 'react-modal';
import { Choose } from 'react-extras';

import './ErrorPageModals.css';
import ErrorPage from '../ErrorPage/ErrorPage';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

const ErrorPageModals = ({ currentModal, closeModal,irctcDowntimeError='',errorId=''}) =>
  (
    <div className="errorModalWrap">
      <Choose>
        <Choose.When condition={currentModal === 'genericError'}>
          <Modal
            isOpen
            ariaHideApp={false}
            className="errorModals"
            style={{
              overlay: {
                backgroundColor: 'rgb(0, 0, 0, 0.6)',
                zIndex: 1,
              },
              customStyles,
            }}
          >
            <div className="makeFlex column end">
              <a onClick={closeModal}><span className="railSprite crossIcon" /></a>
            </div>
            <ErrorPage
              errorImg={'genericerror.png'}
              errorTitle={'Something went wrong'}
              errorMsg={
                'We have saved all your details, please try again.'+errorId
              }
              actionLink={'Back'}
            />
          </Modal>
        </Choose.When>
        <Choose.When condition={currentModal === 'irctcError'}>
          <Modal
            isOpen
            ariaHideApp={false}
            className="errorModals"
            style={{
              overlay: {
                backgroundColor: 'rgb(0, 0, 0, 0.6)',
                zIndex: 1,
              },
              customStyles,
            }}
          >
            <ErrorPage
              errorImg={'irctcError.png'}
              errorTitle={
                'Services closed from 10:58 AM to 11:15 AM'
              }
              errorMsg={
                'We have saved all your details, please try again after some time.'
              }
              actionLink={'Back'}
            />
            <div className="makeFlex column end">
              <a onClick={closeModal}><span className="railSprite crossIcon" /></a>
            </div>
          </Modal>
        </Choose.When>
        <Choose.When condition={currentModal === 'irctcDowntimeError'}>
          <Modal
            isOpen
            ariaHideApp={false}
            className="errorModals"
            style={{
              overlay: {
                backgroundColor: 'rgb(0, 0, 0, 0.6)',
                zIndex: 1,
              },
              customStyles,
            }}
          >
            <ErrorPage
              errorImg={'irctcError.png'}
              errorTitle={
                'IRCTC Services closed'
              }
              errorMsg={
                irctcDowntimeError
              }
              actionLink={'Back'}
            />
            <div className="makeFlex column end">
              <a onClick={closeModal}><span className="railSprite crossIcon" /></a>
            </div>
          </Modal>
        </Choose.When>
        <Choose.When condition={currentModal === 'invalidCaptcha'}>
          <Modal
            isOpen
            ariaHideApp={false}
            className="errorModals"
            style={{
              overlay: {
                backgroundColor: 'rgb(0, 0, 0, 0.6)',
                zIndex: 1,
              },
              customStyles,
            }}
          >
            <ErrorPage
              errorImg={'irctcError.png'}
              errorTitle={
                'Invalid Captcha, Please retry'
              }
              errorMsg={
                'Invalid Captcha, Please retry'
              }
              actionLink={'Back'}
            />
            <div className="makeFlex column end">
              <a onClick={closeModal}><span className="railSprite crossIcon" /></a>
            </div>
          </Modal>
        </Choose.When>
        <Choose.When condition={currentModal === 'internetError'}>
          <Modal
            isOpen
            ariaHideApp={false}
            className="errorModals"
            style={{
              overlay: {
                backgroundColor: 'rgb(0, 0, 0, 0.6)',
                zIndex: 1,
              },
              customStyles,
            }}
          >
            <ErrorPage
              errorImg={'nointernet.png'}
              errorTitle={'No internet connectivity'}
              errorMsg={
                'Please check your internet connectivity and try again, we have saved all your details. '
              }
              actionLink={'Back'}
            />
            <div className="makeFlex column end">
              <a onClick={closeModal}><span className="railSprite crossIcon" /></a>
            </div>
          </Modal>
        </Choose.When>
      </Choose>
    </div>
  );

export default ErrorPageModals;
